export default __webpack_public_path__ + "static/media/port.81b2b0ec.png";